// Hooks
import { useSocialInboxNavigation } from '@/components/pages/conversations/SocialInbox/hooks/useSocialInboxNavigation';
import useTranslation from '@/utils/hooks/translation/useTranslation';

// Libs
import { SOCIAL_INBOX_META } from '@/components/pages/conversations/SocialInbox/const';

// Components
import Badge from '@/components/base/Badge';
import {
    RefreshButton,
    SocialInboxActions,
    SocialInboxFilters,
    SocialInboxTypeTitle
} from '@/components/pages/conversations/SocialInbox';

export function SocialInboxHeader() {
    const { t } = useTranslation('conversations');
    const { currentSocialInbox } = useSocialInboxNavigation();

    return (
        <div className="flex flex-col gap-5 pr-4">
            <div className="flex items-center justify-between gap-2">
                <div className="hidden flex-wrap-reverse items-center gap-2 sm:flex">
                    <SocialInboxTypeTitle classNameTextSize="text-16" type={currentSocialInbox} />

                    {currentSocialInbox === SOCIAL_INBOX_META.dm.key && (
                        <Badge variant="network">{t('social_inbox.instagram_accounts_only')}</Badge>
                    )}
                </div>

                {currentSocialInbox === SOCIAL_INBOX_META.dm.key && <RefreshButton />}
            </div>

            <div className="flex justify-between">
                <SocialInboxFilters />

                <SocialInboxActions />
            </div>
        </div>
    );
}
